import Cookies from 'js-cookie'

// StudentId
export function getStudentId() {
  return Cookies.get('studentId')
}

export function setStudentId(id) {
  return Cookies.set('studentId', id)
}

export function removeStudentId() {
  return Cookies.remove('studentId')
}

// OpenId
export function getOpenId() {
  return Cookies.get('openId')
}

export function setOpenId(id) {
  return Cookies.set('openId', id)
}

export function removeOpenId() {
  return Cookies.remove('openId')
}

// 家长姓名
export function getNickName() {
  return Cookies.get('nickName')
}

export function setNickName(name) {
  return Cookies.set('nickName', name)
}

export function removeNickName() {
  return Cookies.remove('nickName')
}

// 家长头像
export function getAvatar() {
  return Cookies.get('avatar')
}

export function setAvatar(avatar) {
  return Cookies.set('avatar', avatar)
}

export function removeAvatar() {
  return Cookies.remove('avatar')
}

// 学生姓名
export function getName() {
  return Cookies.get('name')
}

export function setName(name) {
  return Cookies.set('name', name)
}

export function removeName() {
  return Cookies.remove('name')
}

// 学生性别
export function getGender() {
  return Cookies.get('gender')
}

export function setGender(gender) {
  return Cookies.set('gender', gender)
}

export function removeGender() {
  return Cookies.remove('gender')
}

